import {useExpandedGroups} from '@hconnect/common/hooks/useExpandGroups'
import {DataTable, Column, ExpandableListItem} from '@hconnect/uikit/src/lib2'
import {Typography} from '@mui/material'
import React from 'react'
import {useTranslation} from 'react-i18next'

import {DataFetchingPlaceholder} from '../components'
import {useRefLinksColumns} from '../hooks'
import {RefLinks} from '../types'

type RefLinksContainerMobileProps = {
  refLinksData: RefLinks[]
  isLoading: boolean
}
type SectionName = RefLinks['sectionName']
type GroupedRefLinks = Record<SectionName, RefLinks[]>

const groupRefLinksDataBySection = (data: RefLinks[]) =>
  data.reduce((acc: GroupedRefLinks, item: RefLinks) => {
    ;(acc[item.sectionName] ??= []).push(item)
    return acc
  }, {})

export const RefLinksMobileContainer: React.FC<RefLinksContainerMobileProps> = ({
  refLinksData,
  isLoading
}) => {
  const {t} = useTranslation()
  const result: GroupedRefLinks = groupRefLinksDataBySection(refLinksData)
  const sections: string[] = Object.keys(result)

  const [expandedSection, toggleExpandedSection] = useExpandedGroups(sections, 'section-expanded')

  const columnsMobile: Column<RefLinks>[] = useRefLinksColumns()

  return isLoading ? (
    <DataFetchingPlaceholder
      isLoading={isLoading}
      height="100%"
      errorMessage={t('errors.sectionsNotFetched')}
    />
  ) : (
    <>
      {sections.map((sectionName) => {
        const sectionResult = result[sectionName]

        return (
          <ExpandableListItem
            key={sectionName}
            id={sectionName}
            isOpen={expandedSection.includes(sectionName)}
            toggleState={(id) => toggleExpandedSection(id)}
            label={<Typography variant="h4">{sectionName}</Typography>}
            content={<DataTable<RefLinks> columns={columnsMobile} data={sectionResult} />}
            showDivider={true}
            data-test-id={`reference-links-${sectionName}`}
          />
        )
      })}
    </>
  )
}
